import Request from '../../../../src/core/gd/data/request'

export default class ApiTemplate {

    static create(payload: any){
        return new Request(this,'POST','templates/create', payload);
    }

    static update(id: ID, payload:any){
        return new Request(this,'PUT','templates/'+id, payload);
    }

    static deleteTemplate(id: ID){
        return new Request(this,'DELETE','templates/'+id);
    }

}
